"use client";

import {useState} from "react";
import type {ColumnFiltersState} from "@tanstack/react-table";

export default function useTableColumnFilters(initialState: ColumnFiltersState = [])
{
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>(initialState);

    const getColumnFilter = (id: string) => columnFilters.find((filter) => filter.id === id)?.value;
    const setColumnFilter = (id: string, value?: any) => setColumnFilters([...columnFilters.filter((filter) => filter.id !== id), ...(value !== undefined ? [{id, value}] : [])]);

    return {columnFilters, setColumnFilters, getColumnFilter, setColumnFilter};
}
